module.exports = __webpack_public_path__ + "img/Active-Managers@2x.ae9b86a9.png";